import React, { Component } from 'react'
import '../stylesheets/components/whatwedolist.scss';
import ReactHtmlParser from 'react-html-parser';
import link from './Tags';

class Whatwedolist extends Component{

	constructor(props){
		super(props)

		this.state = {
			products : [
				{ 
					id: 1,
					image: "images/products/serasa-consulta-cpf.png",
		        	title: "Consulta",
		        	subtitle: "CPF",
		        	text: "Consulte grátis seu <br /> CPF e descubra se você <br /> possui dívidas na Serasa.",
		        	url: "https://www.serasaconsumidor.com.br/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=consultacpf",
		        	slug: "consultacpf"
		        },
		        { 
		        	id: 2,
					image: "images/products/serasa-score.png",
		        	title: "Serasa",
		        	subtitle: "Score",
		        	text: "Uma pontuação de 0 a 1000 que mede a probabilidade de um grupo de pessoas honrar com suas responsabilidades financeiras. Quanto mais próximo do 1000, maior a probabilidade de conseguir um crédito.",
		        	url: "https://www.serasaconsumidor.com.br/score/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=serasascore",
		        	slug: "serasascore"
		        },
		        { 
		        	id: 3,
					image: "images/products/serasa-limpa-nome.png",
		        	title: "Serasa",
		        	subtitle: "Limpa Nome",
		        	text: "Descontos para colocar <br />suas contas em dia.",
		        	url: "https://www.serasaconsumidor.com.br/limpa-nome-online/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=serasalimpanome",
		        	slug: "limpanome"
		        },
		        { 
		        	id: 4,
					image: "images/products/serasa-antifraude.png",
		        	title: "Serasa",
		        	subtitle: "Antifraude",
		        	text: "Monitore seu nome <br />24 horas contra golpes.",
		        	url: "https://www.serasaconsumidor.com.br/antifraude/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=serasaantifraude#!/",
		        	slug: "antifraude"
		        },
		        { 
		        	id: 5,
					image: "images/products/serasa-ecred.png",
		        	title: "Serasa",
		        	subtitle: "Ecred",
		        	text: "Solicite ofertas. <br />de empréstimo e <br />cartão de crédito.",
		        	url: "https://www.serasaconsumidor.com.br/ecred/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=serasaecred",
		        	slug: "ecred"
		        },
		        { 
		        	id: 6,
					image: "images/products/serasa-ensina.png",
		        	title: "Serasa",
		        	subtitle: "Ensina",
		        	text: "Descomplique sua vida<br /> financeira e aprenda a como<br /> cuidar do seu dinheiro.",
		        	url: "https://www.serasaconsumidor.com.br/ensina/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=serasaensina",
		        	slug: "ensina"
		        },
		        { 
		        	id: 7,
					image: "images/products/visa.png",
		        	title: "",
		        	subtitle: "Visa",
		        	text: "Emita grátis o seu <br />cartão pré-pago.",
		        	url: "https://ensina.serasaconsumidor.com.br/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=visa",
		        	slug: "visa"
		        },
		        { 
		        	id: 8,
					image: "images/products/financas-praticas.png",
		        	title: "Finanças",
		        	subtitle: "Práticas",
		        	text: "O programa de educação financeira  <br />criado pela Visa e feito para todos. ",
		        	url: "https://ensina.serasaconsumidor.com.br/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=financaspraticas",
		        	slug: "financaspraticas"
		        },
		        { 
		        	id: 9,
					image: "images/products/pagseguro.png",
		        	title: "",
		        	subtitle: "Pagseguro",
		        	text: "Conheça as maquininhas da <br />PagSeguro e compre a sua.",
		        	url: "https://www.serasaconsumidor.com.br/cadastro-positivo/?utm_source=serasaitinerante&amp;utm_medium=oquelevamos_calltoaction&amp;utm_campaign=pagseguro",
		        	slug: "pagseguro"
		        }
			]
		}

		this.updateProduct = this.updateProduct.bind(this)
	}

	componentDidMount(){
		this.updateProduct(this.state.products[0]);
	}

	updateProduct(obj, e = null) {
		if(e){
			e.preventDefault();
		}

	    return this.setState({ image: obj.image,
	    					   title: obj.title,
	    					   subtitle: obj.subtitle,
	    					   text: obj.text,
	    					   url: obj.url,
	    					   id: obj.id 
	    					});
	}

	render(){
		const itens = this.state.products.map((item) => {
					      return (
					      	<a href=";javascript" onClick={(e) => this.updateProduct(item, e)} className="o-timeline--day" key={item.id}>
					      		<li className="c-whatwedolist__list--item" >
					                <h3 className={ "c-title c-title--size-medium c-title--weight-regular c-title--color-white c-title--align-left o-uppercase c-title--icon c-title--icon-" + item.slug } >
				                    	{ ReactHtmlParser(item.title) } { ReactHtmlParser(item.subtitle) }
					                </h3>
					            </li>
				            </a>
					      )
					    })

		return (
			<section className="o-whatwedolist" id="carregamos" >
				<div className="o-container">

					<div className="o-row" >
						<div className="o-col o-col--width-medium">

							<h2 className="c-title c-title--size-big c-title--family-bold c-title--lineheight-2 c-title--color-white c-title--align-left c-title--border c-title--border-bottom">
								Os serviços do <br />
								Serasa Consumidor <br />
								e muito mais:
							</h2>

							<br /> <br />

							<div className="o-whatwedolist--list o-whatwedolist--list-direction-row" >
								<img src={ process.env.PUBLIC_URL + "/" +  this.state.image } alt={ this.state.title } className="o-whatwedolist--image o-whatwedolist--image-small" /> 
								<div className="o-whatwedolist--list" >
									<p className="c-title c-title--size-small c-title--family-regular c-title--color-white c-title--align-left" >
										{ this.state.title }
									</p>
									<p className="c-title c-title--size-medium c-title--family-bold c-title--color-white c-title--align-left" >
										{ this.state.subtitle }
									</p>
								</div>
							</div>

							<p className="c-title c-title--size-small c-title--lineheight-2 c-title--family c-title--family-regular c-title--color-white c-title--align-left" >
								{ ReactHtmlParser(this.state.text) }
							</p>
							<br />
							<a href={this.state.url} className="c-btn c-btn--color-white" onClick={ (e) => { link({tagaction: 'saiba-mais-servicos', tagtitle: this.state.title + " " + this.state.subtitle}, e) } } target="_blank" rel="noopener">Saiba mais</a>
						</div>

						<div className="o-col">
							<ul className="o-whatwedolist--list">
								{ itens }
				      		</ul>
				      	</div>
			      
	        		</div>
	      		</div>
      		</section>
		)
	}

}

export default Whatwedolist


// WEBPACK FOOTER //
// ./src/components/Whatwedolist.js